import React from 'react'
import { Translate } from 'react-localize-redux'
import Select from 'react-select'
import PropTypes from 'prop-types'

const ReactSelect = ({
  value,
  suggestions,
  onChange,
  placeholder,
  isMulti,
  isEveryOne,
  index,
}) => {
  const options = isEveryOne
    ? [
        { value: 'everyOne', label: <Translate id="videos.tag-everyone" /> },
        ...suggestions,
      ]
    : suggestions

  const change = (newPlayers, { option }) => {
    onChange(newPlayers, option, index)
  }

  return (
    <Select
      value={value}
      isMulti={isMulti}
      options={options}
      onChange={index > -1 ? change : onChange}
      placeholder={placeholder}
    />
  )
}

ReactSelect.defaultProps = {
  value: [],
  suggestions: [],
  placeholder: '',
  isEveryOne: false,
  isMulti: true,
  index: -1,
}

ReactSelect.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isEveryOne: PropTypes.bool,
  isMulti: PropTypes.bool,
  index: PropTypes.number,
}

export default ReactSelect
